import React    from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';  // allows us to provide redux store to components
import AppRouter, { history } from './routers/AppRouter';
import configureStore from './store/configureStore';
// import { login, logout, clearAuthError } from './actions/auth';
// import axios from 'axios';
// import jwt   from 'jsonwebtoken';
import throttle from 'lodash/throttle';
import ReactGA from 'react-ga'    /* Google analytics */

// CSS Imports
import 'normalize.css/normalize.css';   /* this import must appear before all other style files */

//Axolot bootstrap and aniamte  Imports
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "animate.css/animate.min.css";

//Axolot Template SCSS Styles
import "./assets/scss/style.scss";
import "./assets/scss/responsive.scss";

// PitchInClub SCSS Styles
import './styles/styles.scss';
import 'react-dates/lib/css/_datepicker.css';

// import { firebase } from './firebase/firebase';
import LoadingPage from './components/LoadingPage';
import  { saveState } from './store/localStorage';
// import { flushItemListStatus } from './actions/items';

// import { PicPutRequest } from './apis/PicPutRequest';
// import  PicGetRequest  from './apis/PicGetRequest';
// import { logoutInProgress }  from './actions/auth';
// import { startLogout }  from './actions/auth';

// Initialize component name and Google Analytics Id
let compName = 'app.js';
ReactGA.initialize('UA-151608223-1')


// import PicMuiTabs from './components/PicMuiTabs';
// import Typography from '@material-ui/core/Typography';
// import setAuthorizationToken from './utils/setAuthorizationToken';

// **************************************************************************
// M A N A G E   R E D U X   A N D   L O C A L   S T O R A G E
// **************************************************************************

// Store will be recreated everytime application needs to re-render.
// Since we are leveraging local storage, the store will be initialized with
// the state that is saved in local storage.
const store = configureStore();

// Subscribe function will be called everytime redux state changes. saveState()
// will persist redux store to localStorage. Two things to note: 1) state you are saving
// should mirror the state of your combined reducers. 2) saveState is wrapped 
// in throttle method that minimizes writes to local storage to 1x / per second.
store.subscribe(throttle(()=> {
        /* list of reducers below to shadow what you have in your combined reducers */
        let items   =  store.getState().items;
        let auth    =  store.getState().auth;
        let picapp  =  store.getState().picapp;
        let event   =  store.getState().event;
        let participants   =  store.getState().participants;
        let contacts   =  store.getState().contacts;
        let todos   =  store.getState().todos;
        // let itemsToBring =  store.getState().itemsToBring;
        saveState({
            auth,
            picapp,
            event,
            participants,
            contacts,
            items,
            todos
            /* add other reducers here*/
        });
}, 1000));

// **************************************************************************
// M A N A G E   A U T H E N T I C A T I O N
// **************************************************************************

/* Load state from local storage; assign empty object if state is null */
let stateObj = JSON.parse(localStorage.getItem('state')) || {};

/* If auth token exists in local storage, set x-auth header by calling 
   setAuthorizationToken. This header will appear on all subsequent api calls */  
let authToken = ('auth' in stateObj && 'token' in stateObj.auth ) ? stateObj.auth.token : undefined;
// authToken ? console.log("authToken is truthy") : console.log("authToken is falsy");
if (authToken) {
//   console.log(`Set authorization token '${authToken}'`);
//   setAuthorizationToken(authToken);
//   console.log("Set current user here - NOT YET **********");
//   store.dispatch(setCurrentuser(jwt.decode(authToken)));
}

// console.log("This is token from local storage ", authToken)

// **************************************************************************
// C L E A R    E R R O R S / on application refresh
// **************************************************************************

/* check for auth errors */

// let authError = store.getState().auth.error;
// if (authError) {
//     console.log(" Encountered auth error in app.js ", authError);
//     console.log(" Dispatching action to clear it ");
//     store.dispatch(clearAuthError());
// }


// **************************************************************************
// R E N D E R   A P P L I C A T I O N
// **************************************************************************
// console.log("Define Application jsx");
// Define JSX
const jsx = (
    <Provider store={store} >
        <AppRouter />
    </Provider>
)

// Declare function to render app. Following lines of code ensures we only render
// application a single time and not once for login and another time for logout.
// console.log("Declare function to render app");
let   hasRendered = false; 
const renderApp = () => {
    if (!hasRendered) {
        ReactDOM.render(jsx, document.getElementById('app'));
        hasRendered = true;
    }
}

// Renders an animation while waiting to render app
// console.log("Render LoadingPage");
ReactDOM.render(<LoadingPage />, document.getElementById('app'));

// Putting this before renderApp() and commmenting out firebase code below, it renders the 
// app immediately and does not execute firebase authentication code below.
// When ready to implement authentication, uncomment firebase code below and
// comment out the renderApp() statement in the next line.

// console.log("Call function to render app");
renderApp();    

// let reqBody = {
// 	event_id:  "59ee2fe86d616c1f80681263",
// 	items: [
// 	   { item:   "test item number 1",
// 	     quantity: 4,
// 		     contributors: [
// 		       {
// 		         email:  "jane.doe2@gmail.com",
// 		         name:   "Jane Doe" ,
// 		         amount: 1
// 		       },
// 		       {
// 		         email:   "james.barley2@gmail.com",
// 		         name:    "James B." ,
// 		         amount:  3
// 		       }
// 		     ]
// 	  }
//     ]
// }

// let api = new PicPutRequest("UpdateContributionsList");

// api.setUserId("dpborges@gmail.com")
//    .setUri("/event/contributions")
//    .setAuthToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1YmI1NWJmNGE4ODdlODI3ODdlZGVmYzIiLCJhY2Nlc3MiOiJhdXRoIiwiaWF0IjoxNTQ4MzcwNjIyfQ.Ye7laJf-0rd9jUFQf8AvWKHp-gz6157L3vd1e8qKsw8")
//    .setLogTrace(true)
//    .setRequestBody(reqBody);
// api.exec().then( (response) => {
//    console.log("This is response");
//    console.log(response);
// }).catch((error) => {
//    console.log("This is error");
//    console.log(error);
// });

// store.dispatch(startLogout());



// **************************************************************************
// R E N D E R   A P P L I C A T I O N   E N D
// **************************************************************************

// Code below was use to add some expenses and print visible expenses based on our selector
// store.dispatch(addExpense({ description: 'Water Bill', amount: 4500  }));
// store.dispatch(addExpense({ description: 'Gas Bill', amount: 0, createdAt: 1000 }));
// store.dispatch(addExpense({ description: 'Rent', amount: 109500 }));
// console.log("Below we are dispatchng startAddItem")
// store.dispatch(startAddItem(["appstestvalue", "2"], []));
// console.log(store.dispatch(updateItemList(["appstestvalue", "2"])));
// store.dispatch(startAddItem());

// const state = store.getState();
// const visibleExpenses = getVisibleExpenses(state.expenses, state.filters);
// console.log(visibleExpenses)

// let apiurl = 'https://xfuvt5x4i0.execute-api.us-east-1.amazonaws.com/test/signup' 
// let apiurl = 'http://localhost:3000/signup' 

// let postData = {
//     email: "foob9@gmail.com",
//     password: "password123!"
// }


// let axiosConfig = {
//     headers: {
//         'Content-Type': 'text/plain'
//     }
// }

// axios.post(apiurl, postData, axiosConfig)
// .then(function (response) {
//     console.log('RESPONSE START');
//     // console.log(response.data);
//      console.log('x-auth token ', response.headers["x-auth"]);
//     console.log('RESPONSE END');
// }).catch (function (error){
//     console.log(error);
// });

// Following function will be executed everytime authentication state changes (log in and log off), 
// very much like a firebase subscriber.
// firebase.auth().onAuthStateChanged((user) => {    // called when user is authenticated and when unauthenticated
//     if (user) {   // If user exist, we know user just logged in.
//         console.log(`logged in. UID is ${user.uid}`);
//         store.dispatch(login(user.uid)); // call login action to save uid in store
//         renderApp();    
//         // Use history to get access to user's current "location". Only if user is in Login page '/'
//         // do you want to redirect them to dashboard, otherwise they should remain on same page
//         // they are on.
//         if (history.location.pathname === '/') {
//             history.push('/dashboard')
//         }
//     } else {    // If user does not exist, we know user just logged out.
//         console.log(`logged out`);
//         store.dispatch(logout()); // call logout action to clear uid from store
//         renderApp();
//         history.push('/');   // Brings user back, or redirects, to login page upon logout
//     }
// })




// WEBPACK FOOTER //
// ./src/app.js